import LoginPage from "@/project/components/auth/LoginPage.vue";
import SignupPage from "@/project/components/auth/SignupPage.vue";

export default {
  login: {
    title: 'Login Page',
    name: 'login',
    route: '/login',
    checkAuth: true,
    component: LoginPage,
    needAuth: false,
    layoutName: 'auth',
  },
  signup: {
    title: 'Signup Page',
    name: 'signup',
    route: '/register',
    component: SignupPage,
    checkAuth: true,
    needAuth: false,
    layoutName: 'auth',
  },
}
